<script setup lang="ts">
const route = useRoute()

const logo = useTemplateRef('logo')
const stats = useStats()
const { loggedIn } = useUserSession()
const { copy } = useClipboard()
const { headerLinks } = useHeaderLinks()
const { track } = useAnalytics()

const logoContextMenuItems = [
  [{
    label: '将标志复制为SVG',
    icon: 'i-simple-icons-nuxtdotjs',
    onSelect() {
      track('Logo Action', { action: 'Copy SVG' })
      if (logo.value) {
        copy(logo.value.$el.outerHTML, {
          title: 'Nuxt 标志已复制为 SVG',
          description: '你现在可以将其粘贴到你的项目中',
          icon: 'i-lucide-circle-check',
          color: 'success'
        })
      }
    }
  }],
  [{
    label: '浏览设计工具包',
    icon: 'i-lucide-shapes',
    to: '/design-kit',
    onSelect: () => track('Logo Action', { action: 'Browse Design Kit' })
  }]
]

function trackSearchOpen() {
  track('Search Opened')
}

function trackGitHubClick() {
  track('Header Action', { action: 'GitHub Stars' })
}
</script>

<template>
  <UHeader :ui="{ left: 'min-w-0 items-end' }" class="flex flex-col">
    <template #left>
      <NuxtLink to="/" aria-label="返回首页">
        <UContextMenu :items="logoContextMenuItems" size="xs">
          <NuxtLogo ref="logo" class="block w-auto h-6" />
        </UContextMenu>
      </NuxtLink>

      <VersionMenu />
    </template>

    <UNavigationMenu
      :items="headerLinks.map((link) => {
        if (link.to.startsWith('/docs')) {
          return { ...link, children: [] }
        }
        return link
      })"
      variant="link"
      content-orientation="vertical"
      :ui="{ linkLeadingIcon: 'hidden' }"
    />

    <template #right>
      <AgentChatButton />
      <UTooltip text="Search" :kbds="['meta', 'K']" ignore-non-keyboard-focus>
        <UContentSearchButton @click="trackSearchOpen" />
      </UTooltip>

      <template v-if="!loggedIn">
        <UTooltip text="Toggle theme" :kbds="['d']">
          <UColorModeButton />
        </UTooltip>

        <UTooltip text="GitHub Stars">
          <UButton
            icon="i-simple-icons-github"
            to="https://go.nuxt.com/github"
            target="_blank"
            variant="ghost"
            color="neutral"
            square
            :label="stats ? formatNumber(stats.stars) : '...'"
            aria-label="GitHub 上的 Nuxt"
            :ui="{
              label: 'hidden sm:inline-flex'
            }"
            @click="trackGitHubClick"
          />
        </UTooltip>
      </template>

      <HeaderUserMenu v-else />
    </template>

    <template #toggle="{ open, toggle }">
      <HeaderToggle
        :open="open"
        class="lg:hidden"
        @click="() => { track('移动菜单切换', { open: !open }); toggle() }"
      />
    </template>

    <template #body>
      <HeaderBody />
    </template>

    <template v-if="route.path.startsWith('/docs/') || route.path.startsWith('/deploy')" #bottom>
      <HeaderBottom />
    </template>
  </UHeader>
</template>
